import { z } from 'zod';

import { DateStringSchema, TimeStringSchema } from '../../common';
import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint } from '../common';

const GetListingRevenueResponseSchema = z.object({
  priceTiers: z.array(
    z.object({
      priceTierId: z.string().nullable(),
      priceTierName: z.string(),
      revenue: z.number(),
      participantCount: z.number(),
    }),
  ),
  totalCapacity: z.number(),
});

const GetListingRevenueQuerySchema = z.object({
  date: DateStringSchema,
  startTime: TimeStringSchema.optional(),
  sessionDuration: z.string().pipe(z.coerce.number().positive()).optional(), // minutes
});

export const GetListingRevenueEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ listingId, query }: { listingId: string; query: z.input<typeof GetListingRevenueQuerySchema> }) =>
    `/v1/listings/${listingId}/revenue?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetListingRevenueResponseSchema,
  querySchema: GetListingRevenueQuerySchema,
});
